// TODO: eliminat the switch statements in BlogLocal and loadPasts that require manual location name updating

import { writable } from 'svelte/store';
import { getPlacenames } from './location.api'; // Import your API function

// Define placenamesStore as an array of strings
const placenamesStore = writable<string[]>([]); // Specify the type as an array of strings

export const loadPlacenames = async (page = 0, pageSize = 100) => {
	try {
		const placenames: string[] = await getPlacenames(page, pageSize); // Ensure the placenames are typed correctly
		placenamesStore.set(placenames);
	} catch (error) {
		console.error('Error loading placenames:', error);
	}
};

export default placenamesStore;
